module.exports = __webpack_public_path__ + "5f467e780ed0aead6614d85dcca181e1.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.eot
// module id = 1018
// module chunks = 0